export const getCurrentUrl = (): string => {
    if (typeof window !== "undefined") {
        return window.document.URL;
    }
    return "";
};

export const getDataLayer = (): any[] => {
    if (typeof window === "undefined") return [];
    return ((window as any).dataLayer = (window as any).dataLayer || []);
};

export const getPageSource = (url: string, fallback: string): string => {
    const u = url.toLowerCase();

    if (u.includes("search")) return "Search Results";
    if (u.includes("cart")) return "Cart Lines";
    if (u.includes("category/all")) return "Brand Results";
    if (u.includes("savedorders")) return "Saved Order Details Page";
    if (u.includes("orders/details")) return "Order History Details";
    if (u.includes("checkout/review")) return "Order Review";
    if (u.includes("brand")) return "Brand Results";
    if (u.includes("quote/confirmation")) return "Quote Confirmation";
    if (u.includes("mylists")) return "Product Wish List";
    if (u.includes("checkout/reviewandsubmit")) return "Order Review";
    if (u.includes("orderconfirmation")) return "Order Confirmation";
    if (u.includes("category")) return "Category Results";
    if (u.includes("staticlist")) return "Shared Cart";
    if (u.includes("orders/details")) return "Orders Details";
    if (u.includes("quote/quotedetail")) return "Quote Details";
    return fallback;
};
